import React, { PropsWithChildren, useCallback, useReducer } from 'react'
import MasterContext, { initialState } from './master.context';
import { ActionPayload, ActionType, State } from './type';

interface Props {

}

export const MasterContextProvider: React.FC<PropsWithChildren<Props>> = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const handleDispatch = useCallback((callback: (state: State, dispatch: React.Dispatch<ActionPayload>) => void) => {
        callback?.(state, dispatch)
    }, [state, dispatch])

    return (
        <MasterContext.Provider value={{ state, dispatch: handleDispatch }}>
            {children}
        </MasterContext.Provider>
    );
};

function reducer(state: State, action: ActionPayload): State {
    switch (action.type) {
        case ActionType.GET_CANCELLATION_REASON_SUCCESS:
            return {
                ...state,
                cancellationReason: action.payload.cancellationReason,
                type: action.payload.type,
            };
        default:
            return state;
    }
}